<template>
  <div class="multiple-specs">
    <Button
      v-if="showAddButton"
      icon="md-add"
      @click="addItem"
      long
      class="add-btn spec-add-btn"
      >新增规格</Button
    >
    <div class="title">
      <span class="col">规格名称</span>
      <span class="col2">规格值</span>
      <span class="col">操作</span>
    </div>
    <div class="row" v-for="(item, i) in rawSpecs" :key="i">
      <span class="col">
        <Input v-model="item.key" size="small" />
      </span>
      <span class="col2">
        <Tag
          v-for="(_item, i) in item.value"
          :key="_item"
          closable
          @on-close="handleCloseSpecsValue(item, i)"
          >{{ _item }}</Tag
        >
        <t-popup
          v-model="item.addValuePopupVisible"
          placement="bottom"
          trigger="click"
          destroy-on-close
          show-arrow
          :z-index="3000"
          overlay-inner-class-name="sku-batch-popup-inner"
          :overlay-inner-style="{ padding: '8px' }"
        >
          <Button icon="ios-add" type="dashed" size="small" class="add"></Button>
          <div slot="content" class="sku-batch-popper">
            <Input
              v-model="currentRowValueItem"
              size="small"
              placeholder="请输入"
              @on-enter="handleAddSpecsValue(item)"
            />
            <Button
              type="primary"
              size="small"
              @click="handleAddSpecsValue(item)"
              >确定</Button
            >
          </div>
        </t-popup>
      </span>

      <span class="col">
        <Button
          icon="md-trash"
          size="small"
          @click="removeItem(i)"
          long
          class="remove-btn"
        />
      </span>
    </div>
    <Button
      @click="createSKU"
      long
      class="add-btn sku-generate-btn"
      type="primary"
      >点击生成SKU</Button
    >
    <Table
      class="mt10 sku-table"
      :data="skus"
      :columns="skuTableColumns"
      no-data-text="暂无SKU"
    ></Table>
    <t-dialog
      theme="warning"
      header="注意"
      body="生成规格将清空现有规格数据、是否继续？"
      :visible.sync="createSkuConfirmVisible"
      confirm-btn="继续"
      cancel-btn="取消"
      width="420"
      :z-index="3000"
      @confirm="confirmCreateSKU"
    />
  </div>
</template>
<style lang="stylus" scoped>
.multiple-specs
  .col
    flex: 1
    text-align: center

  .col2
    flex: 2.5
    padding: 0 10px

  .title
    display: flex
    justify-content: space-around

    .col2
      text-align: center

  .add-btn
    margin-top: 10px

  .row
    width: 100%
    display: flex
    margin-bottom: 10px

    .remove-btn
      width: 50px
      margin-left: 10px

  .sku-batch-header
    display: inline-flex
    align-items: center
    gap: 4px
    white-space: nowrap

    .required
      color: #ed4014

    .batch-action
      color: #1f5fff
      cursor: pointer
      font-weight: 400
      line-height: 1

  .sku-batch-popper
    display: flex
    align-items: center
    width: 200px
    overflow: visible

    .ivu-input-wrapper
      width: 132px

    .ivu-btn
      height: 32px
      min-width: 58px
      border-radius: 0 4px 4px 0
</style>
<style lang="stylus">
.sku-batch-header
  display: inline-flex
  align-items: center
  gap: 4px
  white-space: nowrap

  .required
    color: #ed4014 !important

  .batch-action
    color: #1f5fff !important
    cursor: pointer
    font-weight: 400
    line-height: 1

.sku-batch-popup-inner
  width: 200px !important
  min-width: 200px
  max-width: 200px
  z-index: 3000
  overflow: visible

  .sku-batch-popper
    display: flex
    align-items: center
    width: 184px
    overflow: visible

    .ivu-input-wrapper
      width: 126px
      flex: 0 0 126px

    .ivu-input
      height: 32px
      border-radius: 4px 0 0 4px

    .ivu-btn
      height: 32px
      min-width: 58px
      flex: 0 0 58px
      margin-left: 0
      border-radius: 0 4px 4px 0
</style>
<script>
export default {
  props: ['value', 'skus', 'extraSpecs', 'max'],
  data() {
    return {
      showAddButton: true,
      rawSpecs: [],
      currentRowValueItem: '',
      batchValues: {
        price: '',
        priceMarket: '',
        priceCost: '',
        stock: '',
      },
      batchPopupVisible: {
        price: false,
        priceMarket: false,
        priceCost: false,
        stock: false,
      },
      createSkuConfirmVisible: false,
      skuTableColumns: [],
      skuTableMustColumns: [
        {
          title: '操作',
          width: 54,
          fixed: 'left',
          render: (h, { index }) => {
            return (
              <Button
                icon="md-trash"
                size="small"
                class="remove-btn sku-remove-btn"
                onclick={() => {
                  this.skus.splice(index, 1)
                }}
              />
            )
          },
        },
        {
          title: '图片',
          width: 78,
          render: (h, { row, index }) => {
            return (
              <Upload
                class="sku-upload"
                action=""
                before-upload={(file) => {
                  return this.skuUploadImage(index, file)
                }}
              >
                <div class="sku-upload-card">
                  {row.image ? (
                    <img src={this.$envConst.IMAGE_ORIGIN + row.image} />
                  ) : (
                    <span class="sku-upload-plus">+</span>
                  )}
                </div>
              </Upload>
            )
          },
        },
        {
          title: '销售价',
          minWidth: 100,
          renderHeader: (h) => this.renderBatchHeader(h, 'price', '销售价'),
          render: (h, { index }) => this.renderPriceInput(h, index, 'price'),
        },
        {
          title: '市场价',
          minWidth: 100,
          renderHeader: (h) =>
            this.renderBatchHeader(h, 'priceMarket', '市场价'),
          render: (h, { index }) =>
            this.renderPriceInput(h, index, 'priceMarket'),
        },
        {
          title: '成本价',
          minWidth: 100,
          renderHeader: (h) => this.renderBatchHeader(h, 'priceCost', '成本价'),
          render: (h, { index }) =>
            this.renderPriceInput(h, index, 'priceCost'),
        },
        {
          title: '库存',
          minWidth: 100,
          renderHeader: (h) => this.renderBatchHeader(h, 'stock', '库存'),
          render: (h, { index }) => this.renderPriceInput(h, index, 'stock'),
        },
      ],
      needSize: false,
      extraSpecsForm: {
        extraSpecs: {
          label: '附加尺寸',
          type: 'specs',
          specType: 0,
          max: 1,
          value: [],
          options: [
            {
              id: 6,
              code: 'size',
              name: '尺寸',
              vals: [
                {
                  id: 37,
                  attrId: 6,
                  value: '高',
                  symbol: 'height',
                  type: 'number',
                },
                {
                  id: 36,
                  attrId: 6,
                  value: '宽',
                  symbol: 'width',
                  type: 'number',
                },
                {
                  id: 35,
                  attrId: 6,
                  value: '长',
                  symbol: 'length',
                  type: 'number',
                },
              ],
            },
          ],
        },
      },
    }
  },
  inject: ['formData'],
  watch: {
    value: {
      handler(newValue) {
        // 此处value值等于产品详情对象的specs
        this.rawSpecs = []
        this.skuTableColumns = []
        newValue.forEach((item) => {
          // 通过specs生成SKU表格的动态列
          this.skuTableColumns.push({
            title: item.name,
            width: 115,
            key: item.code,
          })
          // 回显SKU配置表单
          this.rawSpecs.push({
            key: item.name,
            value: item.vals.map((val) => val.value),
            addValuePopupVisible: false,
          })
        })
        // 合并sku表格列
        const operationColumn = this.skuTableMustColumns[0]
        const otherMustColumns = this.skuTableMustColumns.slice(1)
        this.skuTableColumns = [
          operationColumn,
          ...this.skuTableColumns,
          ...otherMustColumns,
        ]
      },
      immediate: true,
    },
    extraSpecs: {
      handler(newValue) {
        // console.log('extraSpecs改变', newValue)
        if (newValue && newValue.length > 0) {
          this.needSize = true
          this.extraSpecsForm.extraSpecs.value = newValue.map((item) => {
            item.valsOptions = [
              {
                value: '高',
                symbol: 'height',
              },
              {
                value: '宽',
                symbol: 'width',
              },
              {
                value: '长',
                symbol: 'length',
              },
            ]
            item.valsSelect = item.vals.map((val) => val.value)
            return item
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    renderBatchHeader(h, field, title) {
      return (
        <div class="sku-batch-header">
          <span>{title}</span>
          <span class="required" style={{ color: '#ed4014' }}>
            *
          </span>
          {h(
            't-popup',
            {
              props: {
                visible: this.batchPopupVisible[field],
                content: () => (
                  <div
                    class="sku-batch-popper"
                    onmousedown={(event) => event.stopPropagation()}
                  >
                    <Input
                      size="small"
                      placeholder="请输入"
                      value={this.batchValues[field]}
                      onInput={(value) => {
                        this.$set(this.batchValues, field, value)
                      }}
                    />
                    <Button
                      type="primary"
                      size="small"
                      onclick={() => this.applyBatchPrice(field)}
                    >
                      确定
                    </Button>
                  </div>
                ),
                overlayInnerClassName: 'sku-batch-popup-inner',
                overlayInnerStyle: { padding: '8px' },
                zIndex: 3000,
                destroyOnClose: false,
                showArrow: true,
                trigger: 'click',
                placement: 'bottom',
                onVisibleChange: (visible, context) => {
                  this.handleBatchPopupVisibleChange(field, visible, context)
                },
              },
            },
            [
              <span
                class="batch-action"
                style={{ color: '#1f5fff', cursor: 'pointer', fontWeight: 400 }}
              >
                批量
              </span>,
            ]
          )}
        </div>
      )
    },
    handleBatchPopupVisibleChange(field, visible, context = {}) {
      if (!visible && this.isBatchPopupInnerEvent(context)) return
      this.$set(this.batchPopupVisible, field, visible)
    },
    isBatchPopupInnerEvent(context) {
      let target = context && context.e && context.e.target
      while (target) {
        if (
          target.classList &&
          (target.classList.contains('sku-batch-popup-inner') ||
            target.classList.contains('sku-batch-popper'))
        ) {
          return true
        }
        target = target.parentNode
      }
      return false
    },
    renderPriceInput(h, index, field) {
      const appendSlot =
        field === 'stock'
          ? []
          : [
              h(
                'span',
                {
                  slot: 'append',
                },
                '￥'
              ),
            ]
      return h(
        'Input',
        {
          props: {
            size: 'small',
            value: this.skus[index][field],
            placeholder: '请输入',
          },
          on: {
            'on-change': (event) => {
              this.$set(this.skus[index], field, event.target.value * 1)
            },
          },
        },
        appendSlot
      )
    },
    applyBatchPrice(field) {
      const value = this.batchValues[field]
      if (value === '' || value === null || value === undefined) return
      const numberValue = value * 1
      this.skus.forEach((item, index) => {
        this.$set(this.skus, index, {
          ...item,
          [field]: numberValue,
        })
      })
      this.$set(this.batchPopupVisible, field, false)
    },
    addItem() {
      // if (this.options.length === 0)
      //   return this.$Message.warning('请先选择产品分类')
      let newValueItem = {
        key: '',
        value: [],
        addValuePopupVisible: false,
      }
      this.rawSpecs.push(newValueItem)
    },
    removeItem(i) {
      if (this.rawSpecs.length === 1)
        return this.$Message.warning('至少需要1条数据')
      this.$delete(this.rawSpecs, i)
    },
    handleAddSpecsValue(row) {
      row.value.push(this.currentRowValueItem)
      this.currentRowValueItem = ''
      this.$set(row, 'addValuePopupVisible', false)
    },
    handleCloseSpecsValue(row, i) {
      row.value.splice(i, 1)
    },
    createSKU() {
      if (this.rawSpecs.length === 0)
        return this.$Message.warning('请先添加规格')
      this.createSkuConfirmVisible = true
    },
    confirmCreateSKU() {
      this.createSkuConfirmVisible = false
      const specs = {}
      this.rawSpecs.forEach((item) => {
        specs[item.key] = item.value
      })
      this.$axios
        .post('/mall/product/sku/gen', {
          specs,
          skus: this.skus,
        })
        .then((data) => {
          this.$emit('change', {
            prop: 'value',
            value: data.specs,
          })
          this.$emit('change', {
            prop: 'skus',
            value: data.skus.map((item) => {
              item.price = item.price || this.formData.price
              item.priceCost = item.priceCost || this.formData.priceCost
              item.priceMarket =
                item.priceMarket || this.formData.priceMarket
              item.stock = item.stock || 0

              item.specName.forEach((name, i) => {
                item[name] = item.specVal[i]
              })
              return item
            }),
          })
        })
    },
    skuUploadImage(index, file) {
      const formDate = new FormData()
      formDate.append(
        'folder',
        `/goods/spces/images/${this.$dayjs().format('YYYYMMDD')}`
      )
      formDate.append('file', file)
      this.$axios.post('/funs/upload/image', formDate).then((data) => {
        this.$set(this.skus, index, { ...this.skus[index], image: data })
      })
      return false
    },
    switchNeedSize(value) {
      // console.log('附加尺寸开关状态改变')
      this.needSize = value
      if (value) {
        this.$nextTick(() => {
          this.$emit('change', {
            prop: 'extraSpecs',
            value: [
              {
                code: 'size',
                input: true,
                name: '尺寸',
                type: 2,
                vals: [
                  { value: '长', symbol: 'length' },
                  { value: '宽', symbol: 'width' },
                  { value: '高', symbol: 'height' },
                ],
                valsOptions: [
                  {
                    value: '高',
                    symbol: 'height',
                  },
                  {
                    value: '宽',
                    symbol: 'width',
                  },
                  {
                    value: '长',
                    symbol: 'length',
                  },
                ],
                valsSelect: ['高', '宽', '长'],
              },
            ],
          })
        })
      } else {
        this.$emit('change', {
          prop: 'extraSpecs',
          value: [],
        })
      }
    },
  },
}
</script>
